import {Link, useLocation} from "react-router-dom";
import type {CategoryNavLink} from "@corporatesclub/shared";

type Props = {
  parentLabel?: string;
  title: string;
  links: CategoryNavLink[];
};

export function CategoryPageHero({parentLabel, title, links}: Props) {
  const {pathname} = useLocation();
  return (
    <header className="cc-categoryHero cc-infoPage__hero">
      <div className="cc-infoPage__heroBg" aria-hidden="true">
        <span className="cc-infoPage__heroOrb cc-infoPage__heroOrb--a" />
        <span className="cc-infoPage__heroOrb cc-infoPage__heroOrb--b" />
        <span className="cc-infoPage__heroOrb cc-infoPage__heroOrb--c" />
      </div>
      <div className="cc-categoryHero__inner cc-infoPage__heroInner">
        {parentLabel ? <p className="cc-categoryHero__parent">{parentLabel}</p> : null}
        <h1 className="cc-categoryHero__title">{title}</h1>
        {links.length ? (
          <nav className="cc-categoryHero__grid" aria-label="Subcategories">
            {links.map((link) => {
              const active = pathname === link.url || pathname.startsWith(`${link.url}/`);
              return (
                <Link
                  key={link.url}
                  to={link.url}
                  className={`cc-categoryHero__card anim${active ? " isActive" : ""}`}
                  aria-current={active ? "page" : undefined}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>
        ) : null}
      </div>
    </header>
  );
}
